<template>
  <div class="devOps_producerSpaceSet">
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px" style="margin-top: 10px;">
      <el-form-item label="菜单名">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.menu_name" />
      </el-form-item>
      <el-form-item label="类型">
        <el-select size="mini" autocomplete="off" v-model="form.menu_type" collapse-tags filterable clearable placeholder="请选择类型">
          <el-option v-for="(key, value) in allType" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="mini" autocomplete="off" v-model="form.menu_status" collapse-tags filterable clearable placeholder="请选择状态">
          <el-option v-for="(key, value) in allStatus" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="权限校验">
        <el-select size="mini" autocomplete="off" v-model="form.access_check" collapse-tags filterable clearable placeholder="请选择状态">
          <el-option v-for="(key, value) in allAuthStatus" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="formSearch('reset','search')" v-if="menu.btn_menu_query">查询
        </el-button>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="showDialogVisible('createMenu')" v-if="menu.btn_menu_add">新增菜单
        </el-button>
      </el-form-item>
    </el-form>
    <div style="height: 65vh">
      <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable" style="margin-top:0;" :cell-style="getRowClass" :data="tableData">
        <el-table-column prop="menu_id" label="编号" width="80"></el-table-column>
        <el-table-column prop="menu_name" label="菜单"></el-table-column>
        <el-table-column prop="menu_type" label="类型"></el-table-column>
        <el-table-column prop="menue_code" label="菜单编码"></el-table-column>
        <el-table-column prop="menu_all_url" label="菜单全路径"></el-table-column>
        <el-table-column prop="menu_access_check" label="权限校验"></el-table-column>
        <el-table-column prop="menu_status" label="状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div style="display: flex;" >
              <el-button v-show="menu.btn_menu_detail" type="warning" round size="mini" @click="showDialogVisible('createMenu', scope.row,true)">查看</el-button>
              <el-button  v-show="menu.btn_menu_edit"  type="primary" round size="mini" @click="showDialogVisible('createMenu', scope.row)">编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block devOpsSpace_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="total">
      </el-pagination>
    </div>
    <createMenu  v-if="dialogVisible.createMenu" :dialogVisible='dialogVisible.createMenu' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :isEdit="isEdit"></createMenu>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {getDevOpsSpaceSettingMenuListApi} from "@/server/tops/devOps";
import createMenu from '@/views/tops/devOps/settingSpace/components/menu/createMenu.vue'
import {getDevOpsSpaceMenuListListApi} from "@/server/tops/base";
export default {
  components: {createMenu },
  data() {
    return {
      tableData: [],
      searchData: [],
      form:{
        menu_name:'',
        menu_type:'',
        menu_status:'',
      },
      dialogVisible:{
        createMenu: false,
      },
      checkedInfo:{},
      currentPage: 1,
      pageSize:10,
      total:0,
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      userId:'',
      isEdit: true,
      menu:{},
      allStatus:{'0':'无效','1':'有效'},
      allType:{'1':'一级菜单','2':'二级菜单','3':'按钮'},
      allAuthStatus:{'0':'否','1':'是'},
    }
  },
  async created() {
    await this.getAuth();
    const userId = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
   this.username = username;
    this.userId = userId;
    await this.getNewData();

  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allMenuList: (state) => state.devOps.ALLMENULIST,
        }
    ),
  },
  methods: {
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    async getNewData(){
      let params = {};
      for (const key in this.form) {
        const val = this.form[key];
        params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
      }
      params.pageNo = this.currentPage
      params.pageSize = this.pageSize
      getDevOpsSpaceSettingMenuListApi(params).then((res)=>{
        this.tableData = res.data;
        this.total = res.count;
      })
    },
    // 弹出模板
    async showDialogVisible(type, row = {},isLook = false) {
      if(isLook){
        this.isEdit = false;
      }else{
        this.isEdit = true;
      }
      this.dialogVisible[type] = true;
      this.checkedInfo = row;
    },
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      await this.getNewData();
    },
    formSearch(){
      let newTableData = [];
      this.currentPage = 1;
      this.getNewData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1;
      this.getNewData();
    },
    handleCurrentChange(val) {
      this.getNewData();
      //this.currentPage = val
    },
    async getAuth() {
      let menu = {}
      await getDevOpsSpaceMenuListListApi().then((res) => {
        res.data.btnList.forEach((item) => {
            menu[item.code] = 1;
        })
      })
      this.menu = menu;
    },
  }
}
</script>
<style lang="scss">
.devOps_producerSpaceSet{
  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}
.el-message-box__wrapper {
  bottom: initial !important;
  top:10%;
}
</style>
